/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import "./ErrorBody.scss";
import React from "react";
import { ExpiryErrorBody } from "./expiry-error";
import { PageErrorBody } from "./page-error";
import { ServiceErrorBody } from "./service-error";
import {
  ApplicationErrorStatus,
  TelemetryLogs,
  TelemetryErrorPageLogs,
} from "../constants";
import { ActionType, EventName } from "@microsoftit/telemetry-extensions-npm";
import { logTelemetry } from "../../services/telemetry/telemetryWrapper";

interface ErrorProps {
  errorStatus: ApplicationErrorStatus;
}

export const ErrorBody: React.FC<ErrorProps> = ({ errorStatus }) => {
  React.useEffect(() => {
    if (errorStatus === ApplicationErrorStatus.DOWN) {
      logTelemetry(
        TelemetryLogs.PageViews,
        TelemetryLogs.PostOTPVerification,
        ActionType.User,
        TelemetryErrorPageLogs.ServerErrorPage,
        EventName.PageLoad
      );
    } else if (errorStatus === ApplicationErrorStatus.INVALID) {
      logTelemetry(
        TelemetryLogs.PageViews,
        TelemetryLogs.PostOTPVerification,
        ActionType.User,
        TelemetryErrorPageLogs.PageErrorPage,
        EventName.PageLoad
      );
    }
  }, [errorStatus]);
  return (
    <div className="ms-ac-referenceview-error-app-body">
      <div className="ms-ac-referenceview-error-action-container">
        {
          errorStatus === ApplicationErrorStatus.INVALID ? (
            <PageErrorBody />
          ) : errorStatus === ApplicationErrorStatus.DOWN ? (
            <ServiceErrorBody />
          ) : errorStatus === ApplicationErrorStatus.EXPIRED ? (
            <ExpiryErrorBody />
          ) : (
            <ServiceErrorBody />
          ) // default if things are working not as expected.
        }
      </div>
    </div>
  );
};
